import Solution from '@/components/Solution/solution.vue';
import DeviceSolution from '@/components/Device/Solution/solution.vue';
/**
 * 设备列表显示字段
 * @type {{Array}
 */
export const deviceListColumns = [
    // {
    //     type: 'selection',
    //     minWidth: 60,
    //     align: 'center'
    // },
    // {
    //     title: '设备编号',
    //     slot:'设备编号',
    //     minWidth:100
    // },
    {
        title: '设备信息',
        slot:'设备信息',
        minWidth:320
    },
    // {
    //     title: '设备简介',
    //     slot:'设备简介',
    //     minWidth:100,
    //     align: 'center'
    // },
    {
        title: '技术参数',
        slot:'技术参数',
        minWidth:100,
        align: 'center'
    },
    // {
    //     title: '工作原理',
    //     slot:'工作原理',
    //     minWidth:100,
    //     align: 'center'
    // },
    // {
    //     title: '使用维护',
    //     slot:'使用维护',
    //     minWidth:100,
    //     align: 'center'
    // },
    {
        title: '故障信息',
        slot:'故障解析',
        minWidth:100,
        align: 'center'
    },
    {
        title: '机械图册',
        slot:'机械图册',
        minWidth:100,
        align: 'center'
    },
    {
        title: '电气图册',
        slot:'电气图册',
        minWidth:100,
        align: 'center'
    },
    // {
    //     title: '结构部件',
    //     slot:'结构部件',
    //     minWidth:100,
    //     align: 'center'
    // },
    {
        title: '文件资料',
        slot:'文件资料',
        minWidth:100,
        align: 'center'
    },
    {
        title: '备品备件',
        slot:'备品备件',
        minWidth:100,
        align: 'center'
    },
    {
        title: '操作',
        slot:'操作',
        minWidth: 150,
        align: 'center',
        fixed: 'right'
    },
]
/**
 * 资料文件显示字段
 * @type {{Array}
 */
export const deviceDataColumns = [
    {
        type: 'selection',
        width: 60,
        align: 'center'
    },
    {
        title: '序号',
        slot:'序号',
        width: 60,
        align: 'center'
    },
    {
        title: '文件名称',
        slot:'文件名称',
    },
    {
        title: '文件大小',
        slot:'文件大小',
        width:100,
    },
    {
        title: '上传时间',
        width:160,
        key:'uploadTime',
    },
    {
        title: '操作',
        slot:'操作',
        // fixed: 'right',
        align: 'center'
    },
    {
        title: '移动排序',
        slot:'移动排序',
        width:120,
        align: 'center',
    },
]
export const deviceFileColumns = [
    {
        type: 'selection',
        width: 60,
        align: 'center'
    },
    {
        title: '文件名',
        minWidth:180,
        slot:'文件名',
        sortable: true
    },
    {
        title: '上传时间',
        width:140,
        slot:'上传时间',
        sortable: true
    },
    {
        title: '文件类型',
        slot:'文件类型',
        width:100,
    },
    {
        title: '大小',
        slot:'大小',
        width:100,
        sortable: true
    },
    {
        title: '操作',
        slot:'操作',
        // fixed: 'right',
        width:235,
        align: 'center'
    },
]
export const FileColumns = [
    {
        type: 'selection',
        width: 60,
        align: 'center'
    },
    {
        title: '文件名',
        minWidth:180,
        slot:'文件名',
        sortable: 'custom'
    },
    {
        title: '上传时间',
        width:140,
        slot:'上传时间',
        sortable: 'custom'
    },
    {
        title: '文件类型',
        slot:'文件类型',
        width:100,
    },
    {
        title: '大小',
        slot:'大小',
        width:100,
    },
    {
        title: '操作',
        slot:'操作',
        // fixed: 'right',
        width:235,
        align: 'center'
    },
]
/**
 * 故障分析显示字段
 * @type {{Array}
 */
export const faultDataColumns = [
    {
        type: 'selection',
        width: 60,
        align: 'center'
    },
    {
        title: '序号',
        slot:'序号',
        width: 60,
        align: 'center'
    },
    {
        title: '故障描述',
        key:'describe',
    },
    {
        title: '故障时间',
        slot:'故障时间',
        align: 'center',
        width:200,
    },
    {
        title: '解决方案',
        type: 'expand',
        align: 'center',
        width:100,
        render: (h, params) => {
            return h(Solution, {
                props: {
                    reasons: params.row.reasons,
                    id:params.row.id
                },

            })
        }
    },
    {
        title: '操作',
        slot:'操作',
        width: 120,
        align: 'center',
    },
    {
        title: '移动排序',
        slot:'移动排序',
        align: 'center',
        width: 120
    },
]
/**
 * 备件统计显示字段
 * @type {{Array}
 */
export const partsColumns = [
    {
        title: '序号',
        slot:'序号',
        width: 60,
        align: 'center'
    },
    {
        title: '备件信息',
        slot:'备件信息',
        minWidth:220
    },
    {
        title: '库存数量',
        slot:'库存数量',
    },
    {
        title: '存放地点',
        slot:'存放地点',
    },
    {
        title: '安装位置',
        slot:'安装位置',
    },
    {
        type: 'expand',
        align: 'center',
        width:20,
        render: (h, params) => {
            return h(DeviceSolution, {
                props: {
                    equipmentId:params.row.ekbequipmentId,
                    sparePartsId:params.row.id
                },

            })
        }
    },
    {
        title: '操作',
        slot:'操作',
        width:120,
    },
    {
        title: '移动排序',
        slot:'移动排序',
        align: 'center',
        width: 120
    },
]
/**
 * 备件台账显示字段
 * @type {{Array}
 */
export const ledgerColumns = [
    {
        title: '序号',
        slot:'序号',
        width: 60,
        align: 'center'
    },
    {
        title:' ',
        slot:'是否作废',
        width:80
    },
    {
        title: '备件名称',
        slot:'备件名称',
    },
    {
        title: '填报日期',
        slot:'填报日期',
    },
    {
        title: '库存变动',
        slot:'库存变动',
    },
    {
        title: '变动数量',
        slot:'变动数量',
    },
    {
        title: '填报人',
        slot:'填报人',
    },
    {
        title: '记录说明',
        slot:'记录说明',
    },
    {
        title: '操作',
        slot:'操作',
        align: 'center',
        width:120,
    },
]
/**
 * 入库显示字段
 * @type {{Array}
 */
export const warehousingColumns = [
    {
        title: '存放地点',
        slot:'存放地点',
        width: 430
    },
    {
        title: '入库数量*',
        slot:'入库数量',
        width:150
    },
    {
        title: '单位',
        slot:'单位',
        width:150
    },
    {
        title: '记录说明',
        slot:'记录说明',
    },
]
/**
 * 出库显示字段
 * @type {{Array}
 */
export const outboundColumns = [
    {
        title: '检修日期*',
        slot:'检修日期',
        width: 158
    },
    {
        title: '检修位置',
        slot:'检修位置',
        width:158
    },
    {
        title: '检修部门*',
        slot:'检修部门',
        width:158
    },
    {
        title: '检修人*',
        slot:'检修人',
        width:200
    },
    {
        title: '更换数量*',
        slot:'更换数量',
        width:150
    },
    {
        title: '单位',
        slot:'单位',
        width:80
    },
    {
        title: '记录说明',
        slot:'记录说明',
    },
]
/**
 * 结构部件显示字段
 * @type {*[]}
 */
export const structuralElementColumns = [
    {
        type: 'selection',
        width: 60,
        align: 'center'
    },
    {
        title: '序号',
        slot:'序号',
        width: 60,
        align: 'center'
    },
    {
        title: '部件名称',
        key:'partsName',
    },
    {
        title: '部件图片',
        slot: '部件图片',
        align: 'center',
    },
    {
        title: '上传时间',
        key:'uploadTime',
    },
    {
        title: '操作',
        slot:'操作',
        align: 'center',
        width: 200,
    },
]
/**
 * 可能的原因显示字段
 * @type {{Array}
 */
export const reasonDataColumns = [
    {
        title:' ',
        width:100
    },
    {
        title: '序号',
        slot:'序号',
        width:100,
        align: 'center',
    },
    {
        title: '故障原因',
        key:'reason',
    },
    {
        title: '操作',
        slot:'操作',
        width:300,
        align: 'center',
    },
    {
        title: '移动排序',
        slot:'移动排序',
        align: 'center',
        width: 200
    },
]
/**
 * 统计显示字段
 * @type {{Array}
 */
export const inventoryDataColumns = [
    {
        title:' ',
        slot:'是否作废',
        width:80
    },
    {
        title: '序号',
        slot:'序号',
        width:60,
        align: 'center',
    },
    {
        title: '填报日期',
        slot:'填报日期',
    },
    {
        title: '库存变动',
        slot:'库存变动',
    },
    {
        title: '数量',
        slot:'数量',
    },
    {
        title: '填报人',
        slot:'填报人',
    },
    {
        title: '记录说明',
        slot:'记录说明',
    },
    {
        title: '操作',
        slot:'操作',
        width:100,
        align: 'center',
    },
]
export const parameterColumns = [
    {
        title: '名称',
        slot:'名称',
    },
    {
        title: '参数',
        slot:'参数',
    },
]
/**
 * 设备标签页数据
 * @type {{}[]}
 */
export const deviceTabs = [
    {
        label:6,
        value:'基础信息'
    },
    // {
    //     label:7,
    //     value:'设备概述'
    // },
    {
        label:9,
        value:'技术参数'
    },
    // {
    //     label:8,
    //     value:'工作原理'
    // },
    // {
    //     label:1,
    //     value:'使用维护'
    // },
    {
        label:5,
        value:'故障信息'
    },
    {
        label:2,
        value:'机械图册'
    },
    {
        label:3,
        value:'电气图册'
    },
    {
        label:0,
        value:'文件资料'
    },
    {
        label:10,
        value:'备品备件'
    }
]

/**
 * 库存变化
 * @type {{}[]}
 */
export const inventory = [
    {
        label:0,
        value:'全部',
    },
    {
        label:1,
        value:'入库',
    },
    {
        label:2,
        value:'出库',
    },
]
